import { awaitAllSafely } from '@vy/utils';
import { useQueryClient } from 'react-query';
import { runMutation } from '../../../../../../utils/vy-mutation';
import { useMorningConnect } from '../../../../../../hooks/requests/integrations';
import { queryKeys } from '../../../../../../services/query-key/query-keys';
import type { MorningRegisterFormControl } from '../register-to-morning/MorningRegisterFormSchema';

export const useConnectToMorning = (
  control: MorningRegisterFormControl,
) => {
  const queryClient = useQueryClient();
  const { setError } = control;
  const mutateAsyncMorningConnect = useMorningConnect();

  return (apiKey: string, secretId: string) =>
    runMutation(
      mutateAsyncMorningConnect,
      { apiKey, secretId },
      {
        pending: 'Connecting...',
        success: 'Connected',
        error: 'Failed to connect',
      },
      {
        onError: () => {
          setError('apiKey', {
            type: 'manual',
            message: 'Invalid API credentials',
          });
          setError('secretId', {
            type: 'manual',
            message: 'Invalid API credentials',
          });
        },
        onSuccess: () =>
          awaitAllSafely(
            queryClient.invalidateQueries(queryKeys.connectedIntegrations()),
            queryClient.invalidateQueries(queryKeys.integrationSettings()),
          ),
      },
    );
};
